<template>
  <div>
    <p style="text-align: center;">
      <!-- ASQMS 订单管理 -->
      <span class="systemFont1">{{ $t("orderManagement.title") }}</span>
    </p>

    <el-row style="top: 17px;">
      <el-col :span="22" :offset="1" style="text-align: left;">
        <!-- 模糊查询 -->
        <el-form
          :model="queryForm"
          label-position="right"
          ref="queryForm"
          label-width="80px"
          class="systemFont1"
        >
          <el-row>
            <!-- 支付时间 -->
            <el-col :span="6">
              <el-form-item
                :label="$t('orderManagement.orderPayTime')"
                style="margin-bottom: 22px"
              >
                <el-date-picker
                  v-model="queryForm.orderPayTime"
                  size="courseSelect"
                  type="date"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  :placeholder="$t('orderManagement.selectDate')"
                  style="width:100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- 订单状态 -->
            <el-col :span="4" :offset="1">
              <el-form-item :label="$t('orderManagement.orderStatus')">
                <el-select
                  v-model="queryForm.orderStatus"
                  size="courseSelect"
                  style="width: 100%"
                  :placeholder="$t('common.pleaseSelect')"
                  clearable
                >
                  <el-option
                    v-for="item in orderStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 发票状态 -->
            <el-col :span="4" :offset="1">
              <el-form-item :label="$t('orderManagement.invoicingFlag')">
                <el-select
                  v-model="queryForm.invoicingFlag"
                  size="courseSelect"
                  style="width: 100%"
                  :placeholder="$t('common.pleaseSelect')"
                  clearable
                >
                  <el-option
                    v-for="item in invoicingStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 支付方式 -->
            <el-col :span="4" :offset="1">
              <el-form-item :label="$t('orderManagement.orderPayType')">
                <el-select
                  v-model="queryForm.orderPayType"
                  size="courseSelect"
                  style="width: 100%"
                  :placeholder="$t('common.pleaseSelect')"
                  clearable
                >
                  <el-option
                    v-for="item in orderPayTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 购买人 -->
          <el-col :span="6">
            <el-form-item :label="$t('orderManagement.purchaser')">
              <el-input
                name="queryForm.param1"
                type="text"
                size="courseSelect"
                v-model="queryForm.param1"
                maxlength="60"
                clearable
                :placeholder="$t('orderManagement.purchaserPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 书籍名称 -->
          <el-col :span="6" :offset="1">
            <el-form-item :label="$t('orderManagement.bookName')">
              <el-input
                name="queryForm.bookName"
                type="text"
                size="courseSelect"
                v-model="queryForm.bookName"
                maxlength="60"
                clearable
                :placeholder="$t('orderManagement.bookName')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col style="width: 200px;">
            <!-- 查询 -->
            <el-button
              type="submit"
              class="submitButton"
              style="margin-left:15px"
              @click="init(true)"
              ><span>{{ $t("common.query") }}</span>
            </el-button>
            <!-- 重置 -->
            <el-button type="submit" class="buttonWidth" @click="reset"
              ><span>{{ $t("common.reset") }}</span>
            </el-button>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
    <!-- 订单一览 -->
    <el-row style="top: 17px ;">
      <el-col :span="22" :offset="1">
        <el-table :data="tableData">
          <!-- 订单编号 -->
          <el-table-column
            fixed="left"
            min-width="180px"
            prop="orderId"
            :label="$t('orderManagement.orderId')"
            align="center"
          ></el-table-column>
          <!-- 订单支付时间 -->
          <el-table-column
            min-width="135px"
            prop="orderPayTime"
            :label="$t('orderManagement.orderPayTime1')"
            align="center"
          >
            <template slot-scope="scope">
              {{ dateFormat(scope.row.orderPayTime) }}
            </template>
          </el-table-column>
          <!-- 书籍详情 -->
          <el-table-column
            min-width="220px"
            prop="bookName"
            :label="$t('orderManagement.bookName1')"
            align="left"
          >
            <template slot-scope="scope">
              <el-row
                style="display: flex;flex-direction: row;align-items: center;justify-content: center"
              >
                <div><img src="@/assets/u240.png" width="50px"/></div>
                <div style="padding: 5px;width: 130px;overflow-wrap: break-word; word-break: break-word;"
                  ><span>{{
                    scope.row.bookName
                  }}</span></div
                >
              </el-row>
            </template>
          </el-table-column>
          <!-- 收件人 -->
          <el-table-column
            prop="email"
            :label="$t('orderManagement.recipientName')"
            align="left"
            width="280px"
          >
            <template slot-scope="scope">
              <el-row>
                <el-col :span="24">
                  {{ scope.row.recipientName }}
                </el-col>
                <el-col :span="24">
                  {{ scope.row.recipientTelephone }}
                </el-col>
                <el-col :span="24">
                  {{
                    stringIfNull(scope.row.province) +
                      stringIfNull(scope.row.city) +
                      stringIfNull(scope.row.area) +
                      stringIfNull(scope.row.detailedAddress)
                  }}
                </el-col>
                <el-col :span="24" v-if="scope.row.countOrderLocation > 1">
                  <el-button
                    type="text"
                    @click="clickAddresseeDetail(scope.row)"
                    ><span>{{ $t("orderManagement.seeThemAll") }}</span>
                  </el-button>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <!-- 单价 -->
          <el-table-column
            prop="unitPrice"
            :label="$t('orderManagement.unitPrice')"
            align="right"
            width="70px"
          ></el-table-column>
          <!-- 购买数量 -->
          <el-table-column
            prop="purchaseNumber"
            :label="$t('orderManagement.purchaseNumber')"
            align="right"
            width="90px"
          ></el-table-column>
          <!-- 支付方式 -->
          <el-table-column
            prop="orderPayType"
            :label="$t('orderManagement.orderPayType')"
            align="center"
            width="90px"
          >
            <template slot-scope="scope">
              {{
                orderPayTypeOptions.filter(
                  item => item.value === Number(scope.row.orderPayType)
                )[0].label
              }}
            </template>
          </el-table-column>
          <!-- 支付金额 -->
          <el-table-column
            prop="entryPrice"
            :label="$t('orderManagement.entryPrice')"
            align="right"
            width="90px"
          >
          </el-table-column>
          <!-- 货币 -->
          <el-table-column
            prop="currency"
            :label="$t('orderManagement.currency')"
            align="center"
            width="60px"
          >
          </el-table-column>
          <!-- 订单状态 -->
          <el-table-column
            prop="orderStatus"
            :label="$t('orderManagement.orderStatus')"
            align="center"
            width="85px"
          >
            <template slot-scope="scope">
              <span
                :style="
                  scope.row.orderStatus === '0'
                    ? 'color:#FD5B4D'
                    : scope.row.orderStatus === '1'
                    ? 'color:#08C846'
                    : 'color:#828282'
                "
              >
                {{
                  orderStatusOptions.filter(
                    item => item.value === Number(scope.row.orderStatus)
                  )[0].label
                }}</span
              >
            </template>
          </el-table-column>
          <!-- 发票状态 -->
          <el-table-column
            prop="invoicingFlag"
            :label="$t('orderManagement.invoicingFlag')"
            align="center"
            width="85px"
          >
            <template slot-scope="scope">
              <span
                :style="
                  scope.row.invoicingFlag === '0'
                    ? 'color:#828282'
                    : 'color:#08C846'
                "
              >
                {{
                  invoicingStatusOptions.filter(
                    item => item.value === scope.row.invoicingFlag
                  )[0].label
                }}</span
              >
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            fixed="right"
            :label="$t('common.operation')"
            align="center"
            width="130px"
          >
            <template slot-scope="scope">
              <!-- 发票 -->
              <el-button
                size="text"
                v-if="scope.row.invoicingFlag === '1'"
                @click="clickInvoiceDetail(scope.row)"
                >{{ $t("orderManagement.invoice") }}
              </el-button>
              <!-- 完成支付 -->
              <el-button
                v-if="scope.row.orderStatus === '2'"
                size="text"
                @click="updateOrderStatus(scope.row, 0)"
                >{{ $t("orderManagement.completeThePayment") }}
              </el-button>
              <!-- 发货 -->
              <el-button
                v-if="scope.row.orderStatus === '0'"
                size="text"
                @click="updateOrderStatus(scope.row, 1)"
                >{{ $t("orderManagement.shipments") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: right; margin: 20px">
          <el-col :span="24">
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPageCo"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSizeCo"
                layout="total, sizes, prev, pager, next"
                :total="totalCo"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 收件人详细 -->
    <el-dialog
      :title="dialogTitle"
      class="roll-dialog"
      :close-on-click-modal="false"
      :visible.sync="dialogV"
      :width="dialogWidth"
      center
      @close="closeDialog"
    >
      <!-- 地址一览 -->
      <AddresseeDetail
        v-if="addresseeDetailFlag"
        :orderId="dialogOrderId"
        ref="addresseeDetailRef"
      ></AddresseeDetail>
      <!-- 发票一览 -->
      <InvoiceDetail v-if="invoiceDetailFlag" :orderId="dialogOrderId" />
    </el-dialog>
  </div>
</template>

<script>
import AddresseeDetail from "./AddresseeDetail.vue";
import InvoiceDetail from "./InvoiceDetail.vue";
import moment from "moment";
export default {
  name: "orderManagement",
  components: { InvoiceDetail, AddresseeDetail },
  data() {
    return {
      userId: "",
      // 弹窗
      dialogV: false,
      addresseeDetailFlag: false,
      dialogOrderId: "",
      invoiceDetailFlag: false,
      dialogWidth: "500px",
      dialogTitle: "",
      // 一览数据
      tableData: [],
      // 查询条件
      queryForm: {
        orderPayTime: "",
        param1: "",
        bookName: "",
        orderStatus: "",
        invoicingFlag: "",
        orderPayType: ""
      },
      // 订单状态
      orderStatusOptions: [
        // 未发货
        { value: 0, label: this.$t("orderManagement.notShipped") },
        // 已发货
        { value: 1, label: this.$t("orderManagement.shipped") },
        // 待支付
        { value: 2, label: this.$t("orderManagement.pendingPayment") }
      ],
      // 发票状态
      invoicingStatusOptions: [
        // 不需要
        { value: "0", label: this.$t("orderManagement.notRequired") },
        // 需要
        { value: "1", label: this.$t("orderManagement.required") }
      ],
      // 支付方式
      orderPayTypeOptions: [
        // 微信
        { value: 0, label: this.$t("orderManagement.weChat") },
        // 支付宝
        { value: 1, label: this.$t("orderManagement.alipay") },
        // PayPal
        { value: 2, label: this.$t("orderManagement.payPal") },
        // 线下支付
        { value: 3, label: this.$t("orderManagement.offlinePayment") }
      ],
      // 当前页
      currentPageCo: 1,
      // 每页件数
      pageSizeCo: 10,
      totalCo: 0
    };
  },
  methods: {
    clickAddresseeDetail(row) {
      // 发货地址
      this.dialogTitle = this.$t("orderManagement.shippingAddress");
      this.dialogWidth = "1200px";
      this.dialogOrderId = row.orderId;
      this.dialogV = true;
      this.addresseeDetailFlag = true;
    },
    clickInvoiceDetail(row) {
      // 发票信息
      this.dialogTitle = this.$t("orderManagement.invoiceInformation");
      this.dialogWidth = "450px";
      this.dialogOrderId = row.orderId;
      this.dialogV = true;
      this.invoiceDetailFlag = true;
    },
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSizeCo = val;
      this.currentPageCo = 1;
      //判断更改页码是否需要查询
      if (this.tableData == undefined || this.tableData.length <= 0) {
        return;
      }
      this.init(false);
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPageCo = val;
      this.init(false);
      // console.log(`当前页: ${val}`);
    },
    // 初始化订单管理一览数据
    init(val) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      if (val) {
        // 分页数据初始化
        this.currentPageCo = 1;
        this.totalCo = 0;
      }
      let url = "/api/orderManagement/getList";
      this.$http
        .post(url, {
          //模糊查询
          ...this.queryForm,
          // 当前页
          currentSizeCo: (this.currentPageCo - 1) * this.pageSizeCo,
          // 页数
          pageSizeCo: this.pageSizeCo,
          // 总数
          totalCo: this.totalCo
        })
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data == null) {
              this.tableData = [];
            } else {
              // 总数取值
              this.totalCo = response.data.data[0].totalCo;
              // 渲染页面
              this.tableData = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 更新发货信息
    updateOrderStatus(row, val) {
      this.$confirm(
        val === 0 ? (this.$t("orderManagement.msg21")+ row.orderId + this.$t("orderManagement.msg22"))
        : (this.$t("orderManagement.msg11")+ row.orderId + this.$t("orderManagement.msg12")),
        {
          // 确定
          confirmButtonText: this.$t("common.confirm"),
          // 取消
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }
      ).then(() => {
        const loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container")
        });
        let url = "/api/orderManagement/updateOrderStatus";
        this.$http
          .post(url, {
            ...row,
            orderStatus: val,
            userId: localStorage.userId
          })
          .then(response => {
            loading.close();
            if (response.data.code === 200) {
              this.handleCurrentChange(this.currentPageCo);
              this.$message({
                type: "success",
                message: this.$t("p0433.operationSuccess")
              });
            }
          })
          .catch(error => {
            loading.close();
            console.log(error);
          });
      });
    },
    // 重置搜索表单
    reset() {
      this.queryForm = {
        orderPayTime: "",
        param1: "",
        bookName: "",
        orderStatus: "",
        invoicingFlag: "",
        orderPayType: ""
      };
      this.init(true);
    },
    closeDialog() {
      this.addresseeDetailFlag = false;
      this.invoiceDetailFlag = false;
      this.init(false);
    },
    // string 判空
    stringIfNull(val) {
      if (val !== null) {
        return val;
      } else {
        return "";
      }
    },
    // 格式化-日期
    dateFormat(time) {
      console.log(time);
      if (time) {
        return moment(time).format("YYYY-MM-DD HH:mm");
      } else {
        return "-";
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

.preSpecificContent {
  font-family: "微软雅黑", sans-serif;
  font-weight: 400;
  color: #666666;
  font-size: 14px;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0px;
}

>>> .el-input--courseSelect .el-input__inner {
  height: 32px !important;
}

.el-button--submit {
  height: 32px;
}

>>> .buttonWidth {
  width: 80px;
  height: 32px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}

//弹窗样式
>>> .roll-dialog .el-dialog__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(85vh - 140px);
}

//弹窗样式
>>> .add_roll-dialog {
  .el-dialog__body {
    padding: 3px 30px;
    overflow-y: auto;
    height: calc(90vh - 140px);
  }
}

.submitButton {
  width: 80px;
  height: 32px;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/Asqms/views/OrderManagement/Index.vue